export const SEARCHBAR_TRACKING_ACTIONS = {
  searchbar_canvas_opened: "searchbar_canvas_opened",
  searchbar_new_search: "searchbar_new_search",
  searchbar_clicked: "searchbar_clicked",
} as const;
